import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
	selector: 'smt-modal',
	templateUrl: 'smt-modal.component.html',
	styleUrls: ['smt-modal.component.scss']
})

export class SmtModalComponent implements OnChanges, OnInit {
	@Input() isActive: boolean;
	@Input() isForm: boolean = false;

	@Input() disableHeader: boolean = false;
	@Input() header: string;

	@Input() body: string;

	@Input() disableFooter: boolean = false;
	@Input() footer: string;

	@Input() allowEscape: boolean = false;
	@Input() allowDropDownOverflow = false;

	@Input() acceptText: string;
	@Input() rejectText: string;

	@Input() acceptCssClass: string;
	@Input() rejectCssClass: string;

	@Input() disableAccept: boolean = false;
	@Input() disableAcceptConditions: () => boolean;
	@Input() type: string = 'default';

	@Output() closeEvent: EventEmitter<string> = new EventEmitter<string>();
	@Output() acceptEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() rejectEvent: EventEmitter<any> = new EventEmitter<any>();
	dynamicHeight: string;
	@HostListener('document:keydown', ['$event']) onKeyDown(evt: any) {
		if (this.allowEscape && evt.key === 'Escape') {
			this.onDismiss('escape');
		}
	}
	
	@HostListener('window:resize', ['$event'])
	onResize(event:any) {	
		this.dynamicHeight =  (window.innerHeight-200) +"px";
	}

	ngOnInit(){
		this.onResize(['$event']);		
	}

	ngOnChanges() {	
		if (this.disableAcceptConditions) {
			this.disableAccept = true;
		}
		else {
			this.disableAccept = false;
		}	
	}

	onAccept(): boolean {
		this.disableAccept = true;
		this.acceptEvent.emit('accept');

		return false;
	}
	

	onReject(): boolean {
		this.disableAccept = true;
		this.rejectEvent.emit('reject');

		return false;
	}

	private onDismiss(closeEvent: string): void {
		this.isActive = false;
		this.closeEvent.emit(closeEvent);
	}
}
